import { IconWrapper, SquareButton } from './ToolbarOptions.style';
import { ReactComponent as GlossaryIcon } from 'icons/icon-question.svg';
import { LinkWithSearchParams as Link } from 'components/base/Link/Link';

export const GlossaryButton = ({ item }) => {
  return (
    <Link to={item.to} {...item.otherProps}>
      <SquareButton>
        <IconWrapper>
          <GlossaryIcon data-pw="glossary" />
        </IconWrapper>
      </SquareButton>
    </Link>
  );
};
